import { BoxId } from "../types/box_id";
import { Turn } from "../types/turn";

export const GOAL_A_BOX_ID = 6;
export const GOAL_B_BOX_ID = 13;

export const GOAL_BOX_IDS = [GOAL_A_BOX_ID, GOAL_B_BOX_ID];

export const TURN_BOX_IDS: Record<Turn, BoxId[]> = {
  A: [0, 1, 2, 3, 4, 5],
  B: [12, 11, 10, 9, 8, 7],
};

export const getOtherSideBoxId = (boxId: BoxId): BoxId | null => {
  if (TURN_BOX_IDS.A.includes(boxId) || TURN_BOX_IDS.B.includes(boxId)) {
    return (12 - boxId) as BoxId;
  }
  return null;
};

export const getGoalBoxId = (turn: Turn) => {
  return turn === "A" ? GOAL_A_BOX_ID : GOAL_B_BOX_ID;
};
